import { ILandingPageProps } from '@interfaces';
import React from 'react';
import {
    StyledWrapper,
    StyledListItem,
    StyledIconWrapper,
} from '../components/atoms/icon-list/icon-list.style';
import { Highlights } from '../components/sections/highlights/highlights';
import {
    GiftIcon,
    ExpertIcon,
    BestpriceIcon,
} from '../components/sections/highlights/highlights.style';
import { theme } from '../style/global-style';
import { portal } from 'src/utils/locale';

export const HighlightsMod = ({
    getLandingPage,
    modulesData,
}: ILandingPageProps['pageProps']): JSX.Element | null => {
    const data = modulesData[`${getLandingPage.type}${getLandingPage.id}`];
    const isCruiseaway = portal === 'au';
    if (!data || !data.exclusives || isCruiseaway) {
        return null;
    }

    const exclusives =
        data.exclusives?.length >= 3
            ? [
                  <StyledWrapper
                      key="highlights-exclusives"
                      color={theme.labels.onlineBookable}
                      data-testid="icon-list-wrapper"
                  >
                      <StyledListItem data-testid="icon-list-item">
                          <StyledIconWrapper>
                              <GiftIcon key="gift" />
                          </StyledIconWrapper>
                          <span>{data.exclusives[0]}</span>
                      </StyledListItem>
                      <StyledListItem data-testid="icon-list-item">
                          <StyledIconWrapper>
                              <ExpertIcon key="expert" />
                          </StyledIconWrapper>
                          <span>{data.exclusives[1]}</span>
                      </StyledListItem>
                      <StyledListItem data-testid="icon-list-item">
                          <StyledIconWrapper>
                              <BestpriceIcon key="bestprice" />
                          </StyledIconWrapper>
                          <span>{data.exclusives[2]}</span>
                      </StyledListItem>
                  </StyledWrapper>,
              ]
            : [];

    return (
        <Highlights
            headline={getLandingPage?.title ? getLandingPage.title : ''}
            key="highlights"
            exclusives={exclusives}
        />
    );
};
